// extracted by mini-css-extract-plugin
module.exports = {"card":"DeviceCard_card__1vz4Y"};